import {
  useSetting,
  useAssignSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { SALE_COLOR_COPY_CHANGE_241030 } from "@faire/web-api--source/indigofair/settings/SALE_COLOR_COPY_CHANGE_241030";
import { useEffect } from "react";

export const useSettingUpdateSaleColorCopy = (): boolean => {
  return useSetting(SALE_COLOR_COPY_CHANGE_241030, false);
};

export const useAssignSettingUpdateSaleColorCopy = () => {
  return useAssignSetting(SALE_COLOR_COPY_CHANGE_241030);
};

export const useGetSettingAndAssignUpdateSaleColorCopy = () => {
  const assignSetting = useAssignSettingUpdateSaleColorCopy();
  useEffect(() => {
    assignSetting();
  }, [assignSetting]);

  return useSetting(SALE_COLOR_COPY_CHANGE_241030, false);
};
